var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlayinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 10,
  height: 14,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M1.403.673a1.07 1.07 0 0 1 1.14.147l6.429 5.358a1.07 1.07 0 0 1 0 1.646L2.543 13.18a1.071 1.071 0 0 1-1.757-.823V1.643c0-.415.24-.793.617-.97",
  clipRule: "evenodd"
})));
export default SvgPlayinline;